"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subitem = void 0;
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importStar(require("react"));
var tags_ga_1 = require("../../../../utils/tags-ga");
var subitem_styles_1 = require("./subitem.styles");
var Subitem = function (props) {
    var _a, _b, _c, _d;
    var _e = (0, react_1.useState)(false), mouseOver = _e[0], setMouseOver = _e[1];
    return (react_1.default.createElement(tags_ga_1.TagsGa, { action: (_a = props.tagsGa) === null || _a === void 0 ? void 0 : _a.action, category: (_b = props.tagsGa) === null || _b === void 0 ? void 0 : _b.category, label: (_c = props.tagsGa) === null || _c === void 0 ? void 0 : _c.label, eventType: (_d = props.tagsGa) === null || _d === void 0 ? void 0 : _d.eventType },
        react_1.default.createElement(react_1.default.Fragment, null,
            !props.ocultarLinha && react_1.default.createElement(subitem_styles_1.SubitemDividerStyled, { "data-testid": "sub-item-linha" }),
            react_1.default.createElement(subitem_styles_1.SubitemButtonStyled, { "data-testid": "sub-item-botao", "data-element": props.dataElement, "data-info": props.dataInfo, "aria-label": props.tooltip ? "".concat(props.label, " ").concat(props.tooltip) : props.label, onClick: function () {
                    props.onClick();
                    setMouseOver(false);
                }, onPointerEnter: function () { return setMouseOver(true); }, onPointerLeave: function () { return setMouseOver(false); }, mouseOver: mouseOver },
                props.tooltip && (react_1.default.createElement(subitem_styles_1.ContentSubitemTooltipStyled, null,
                    react_1.default.createElement(subitem_styles_1.SubitemTooltipStyled, { "data-testid": "sub-item-tooltip" },
                        react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, props.tooltip)))),
                react_1.default.createElement(subitem_styles_1.SubitemLabelStyled, { "data-testid": "sub-item-label", numberOfLines: 2 },
                    react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small", bgColor: mouseOver }, props.label))))));
};
exports.Subitem = Subitem;
